/* ••[1]••••••••••••••••••••••••• ProviderFactory.ts •••••••••••••••••••••••••••••• */

import {
  ProviderConfiguration,
  CommunityProviderType,
  OcontentProviderType,
  ApexProviderType,
} from "./types/Provider";

import LocalProvider from "./providers/community/localProviders/LocalProvider";
import LocalEventsProvider from "./providers/community/localProviders/LocalEventsProvider";
import LocalTipsProvider from "./providers/community/localProviders/LocalTipsProvider";
import LocalUsersProvider from "./providers/community/localProviders/LocalUsersProvider";

import VanillaProvider from "./providers/community/vanillaProviders/VanillaProvider";
import VanillaDiscussionsProvider from "./providers/community/vanillaProviders/VanillaDiscussionsProvider";
import VanillaEventsProvider from "./providers/community/vanillaProviders/VanillaEventsProvider";
import VanillaTipsProvider from "./providers/community/vanillaProviders/VanillaTipsProvider";
import VanillaPollsProvider from "./providers/community/vanillaProviders/VanillaPollsProvider";
import VanillaUsersProvider from "./providers/community/vanillaProviders/VanillaUsersProvider";

import OcontentTwitterPanelProvider from "./providers/ocontent/OcontentTwitterPanelProvider";
import OcontentMiscProvider from "./providers/ocontent/OcontentMiscProvider";
import OcontentIntroTextProvider from "./providers/ocontent/OcontentIntroTextProvider";
import OcontentQuicklinsProvider from "./providers/ocontent/OcontentQuicklinksProvider";
import OcontentYoutubeProvider from "./providers/ocontent/OcontentYoutubeProvider";
import OcontentAnnouncementsProvider from "./providers/ocontent/OcontentAnnouncementsProvider";
import OcontentEventVideoReplayProvider from "./providers/ocontent/OcontentEventVideoReplayProvider";
import OcontentMonthlyThemeProvider from "./providers/ocontent/OcontentMonthlyThemeProvider";

import ApexProvider from "./providers/apex/ApexProvider";
import ApexJiraProvider from "./providers/apex/ApexJiraProvider";
import ApexBugDbProvider from "./providers/apex/ApexBugDbProvider";

type LocalProviders = LocalProvider &
  LocalEventsProvider &
  LocalTipsProvider &
  LocalUsersProvider;

type VanillaProviders = VanillaProvider &
  VanillaDiscussionsProvider &
  VanillaEventsProvider &
  VanillaTipsProvider &
  VanillaPollsProvider &
  VanillaUsersProvider;

// type CommunityProviders = LocalProviders | VanillaProviders;

type OcontentProviders =
  | OcontentTwitterPanelProvider
  | OcontentMiscProvider
  | OcontentIntroTextProvider
  | OcontentQuicklinsProvider
  | OcontentYoutubeProvider
  | OcontentAnnouncementsProvider
  | OcontentEventVideoReplayProvider
  | OcontentMonthlyThemeProvider;

type ApexProviders = ApexProvider & ApexJiraProvider & ApexBugDbProvider;

export default class ProviderFactory {
  static create<T extends VanillaProviders>(
    providerType?: CommunityProviderType,
    providerConfiguration?: ProviderConfiguration
  ): T;
  static create<T extends LocalProviders>(
    providerType?: CommunityProviderType,
    providerConfiguration?: ProviderConfiguration
  ): T;
  static create<T extends OcontentProviders>(
    providerType?: OcontentProviderType,
    providerConfiguration?: ProviderConfiguration
  ): T;
  static create<T extends ApexProviders>(
    providerType?: ApexProviderType,
    providerConfiguration?: ProviderConfiguration
  ): T;
  static create(
    // eslint-disable-next-line
    providerType: any = null,
    providerConfiguration = ProviderConfiguration.vanilla
    // eslint-disable-next-line
  ): any {
    const provider = selectProvider(providerType, providerConfiguration);

    // if (providerConfiguration === ProviderConfiguration.vanilla) {
    //   provider = selectProvider(providerType, ProviderConfiguration.vanilla);
    //   // if (getMode() === "prod") {
    //   // } else {
    //   //   provider = selectProvider(providerType, ProviderConfiguration.local);
    //   // }
    // } else {
    //   provider = selectProvider(providerType, providerConfiguration);
    // }
    return new provider();
  }
}

function selectProvider(
  providerType: CommunityProviderType | OcontentProviderType | ApexProviderType,
  providerConfiguration: ProviderConfiguration
) {
  switch (providerConfiguration) {
    case ProviderConfiguration.local:
      switch (providerType) {
        case CommunityProviderType.Events:
          return LocalEventsProvider;
        case CommunityProviderType.Tips:
          return LocalTipsProvider;
        case CommunityProviderType.Users:
          return LocalUsersProvider;
        default:
          return LocalProvider;
      }
      break;
    case ProviderConfiguration.vanilla: {
      switch (providerType) {
        case CommunityProviderType.Discussions:
          return VanillaDiscussionsProvider;
        case CommunityProviderType.Events:
          return VanillaEventsProvider;
        case CommunityProviderType.Tips:
          return VanillaTipsProvider;
        case CommunityProviderType.Users:
          return VanillaUsersProvider;
        case CommunityProviderType.Polls:
          return VanillaPollsProvider;
        default:
          return VanillaProvider;
      }
      break;
    }
    case ProviderConfiguration.ocontent: {
      switch (providerType) {
        case OcontentProviderType.Twitter:
          return OcontentTwitterPanelProvider;
        case OcontentProviderType.Misc:
          return OcontentMiscProvider;
        case OcontentProviderType.IntroText:
          return OcontentIntroTextProvider;
        case OcontentProviderType.Quicklinks:
          return OcontentQuicklinsProvider;
        case OcontentProviderType.Youtube:
          return OcontentYoutubeProvider;
        case OcontentProviderType.Announcements:
          return OcontentAnnouncementsProvider;
        case OcontentProviderType.EventVideoReplay:
          return OcontentEventVideoReplayProvider;
        case OcontentProviderType.MonthlyTheme:
          return OcontentMonthlyThemeProvider;
      }
      break;
    }
    case ProviderConfiguration.apex: {
      switch (providerType) {
        case ApexProviderType.Parent:
          return ApexProvider;
        case ApexProviderType.Jira:
          return ApexJiraProvider;
        case ApexProviderType.BugDB:
          return ApexBugDbProvider;
      }
      break;
    }
  }
}
